import { ReactNode, Dispatch, SetStateAction } from 'react';

import { SxProps } from '@mui/material';

export enum AppBarPositionEnum {
  TopLeft = 'topLeft',
  TopRight = 'topRight',
  TopCenter = 'topCenter',
  BottomLeft = 'bottomLeft',
  BottomRight = 'bottomRight',
  BottomCenter = 'bottomCenter',
}

export interface IMytaverseAppBar {
  children: ReactNode;
  visiblePart?: ReactNode;
  position?: AppBarPositionEnum;
  sx?: SxProps;
  isCollapsible?: boolean;
  isGroup?: boolean;
  customOrderBarIsOpen?: boolean;
  setCustomOrderBarIsOpen?: Dispatch<SetStateAction<boolean>>;
}
